var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: { title: _vm.$LocalH5("sealOrSign.secondVerrifi") },
      on: { "on-cancel": _vm.oncancel },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "Form",
        {
          ref: "form",
          staticStyle: { padding: "10px 20px 30px 20px" },
          attrs: { model: _vm.form, rules: _vm.formRules, "label-width": 80 },
        },
        [
          _c(
            "FormItem",
            {
              attrs: {
                label: _vm.$LocalH5("sealOrSign.phone"),
                prop: "cellphone",
              },
            },
            [
              _c("Input", {
                attrs: { placeholder: _vm.$LocalH5("sealOrSign.inputEnter") },
                model: {
                  value: _vm.form.cellphone,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form,
                      "cellphone",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.cellphone",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "FormItem",
            {
              attrs: {
                label: _vm.$LocalH5("sealOrSign.sendCode"),
                prop: "code",
              },
            },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "16" } },
                    [
                      _c("Input", {
                        attrs: {
                          placeholder: _vm.$LocalH5("sealOrSign.inputEnter"),
                        },
                        model: {
                          value: _vm.form.code,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "code",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.code",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Col",
                    { attrs: { span: "6", offset: "1" } },
                    [
                      _c(
                        "Button",
                        {
                          attrs: { disabled: _vm.loading || _vm.count > 0 },
                          on: { click: _vm.sendCode },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.count > 0
                                ? _vm.$LocalH5("sealOrSign.countdown", {
                                    key: _vm.count,
                                  })
                                : _vm.$LocalH5("sealOrSign.getValidCode")
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "Button",
            { attrs: { size: "large" }, on: { click: _vm.oncancel } },
            [_vm._v(_vm._s(_vm.$LocalH5("buttonCancel")))]
          ),
          _vm._v(" "),
          _c(
            "Button",
            {
              attrs: {
                type: "primary",
                size: "large",
                disabled: !(_vm.form.cellphone && _vm.form.code),
              },
              on: { click: _vm.onconform },
            },
            [_vm._v(_vm._s(_vm.$LocalH5("buttonConfirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }